/**
 * Base URL for API requests. In development, returns '' so requests go through
 * the CRA proxy (proxy in package.json forwards to localhost:3001).
 * In production, uses REACT_APP_API_URL.
 */
export const getApiUrl = (): string =>
  process.env.NODE_ENV === 'development'
    ? ''
    : (process.env.REACT_APP_API_URL || 'http://localhost:3001');
